export const SUPPLIER = 'SUPPLIER'
export const CHANNEL = 'CHANNEL'
export const TOWER = 'TOWER'
export const ACCOUNT = 'ACCOUNT'
export const OP = 'OP'

// 一些子应用场景可做判断：print打单
export const LOCAL_PRINT = 'PRINT'

export const SOURCE_MAP = {
    [SUPPLIER]: 'SUPPLIER',
    [CHANNEL]: 'CHANNEL',
    [TOWER]: 'TOWER',
    [ACCOUNT]: 'ACCOUNT',
    [OP]: 'OP'
}

export const requestHeaderSource = () => {
    if (PROJECT_CONFIG.terminalName === TOWER || PROJECT_CONFIG.terminalName === PROJECT_CONFIG.darenTerminalName) {
        // 塔内调塔外接口时默认取sc域名
        return PROJECT_CONFIG.supplierTerminalName
    }

    if (PROJECT_CONFIG.terminalName !== TOWER) {
        return SOURCE_MAP[PROJECT_CONFIG.terminalName]
    }
    return SOURCE_MAP[window.MASTER_PROJECT_CONFIG?.terminalName]
}
